<app-main-pages-container>
    <section>
        <h1 translate>privacy_policy_for_site</h1>

        <h2 translate>privacy_policy_h3_1</h2>
        <p translate>privacy_policy_p1</p>

        <h2 translate>privacy_policy_h3_2</h2>
        <p translate>privacy_policy_p2</p>
        <ol>
            <li translate>
                privacy_policy_ul1_1
            </li>
            <li translate>
                privacy_policy_ul1_2
            </li>
            <li translate>
                privacy_policy_ul1_3
            </li>
            <li translate>
                privacy_policy_ul1_4
            </li>
            <li translate>
                privacy_policy_ul1_5
            </li>
            <li translate>
                privacy_policy_ul1_6
            </li>
        </ol>
        <p translate>
            privacy_policy_p3
        </p>
        <h2 translate>
            privacy_policy_h3_3
        </h2>
        <p translate>
            privacy_policy_p4
        </p>
        <ol>
            <li translate>
                privacy_policy_ul2_1
            </li>
            <li translate>
                privacy_policy_ul2_2
            </li>
            <li translate>
                privacy_policy_ul2_3
            </li>
            <li translate>
                privacy_policy_ul2_4
            </li>
            <li translate>
                privacy_policy_ul2_5
            </li>
            <li translate>
                privacy_policy_ul2_6
            </li>
            <li translate>
                privacy_policy_ul2_7
            </li>
            <li translate>
                privacy_policy_ul2_8
            </li>
        </ol>

        <h2 translate>
            privacy_policy_h3_4
        </h2>
        <p>
            {{ 'privacy_policy_p5_1' | translate }}
            <a routerLink="/contacts">{{ 'privacy_policy_p5_2' | translate }}</a>
            {{ 'privacy_policy_p5_3' | translate }}
        </p>

        <h2 translate>
            privacy_policy_h3_5
        </h2>
        <p translate>
            privacy_policy_p6
        </p>

        <h2 translate>
            privacy_policy_h3_6
        </h2>
        <p>
            {{ 'privacy_policy_p7_1' | translate }}
            <a href='https://wikipedia.org/wiki/Cookie'>{{ 'privacy_policy_p7_2' | translate }}</a>
            {{ 'privacy_policy_p7_3' | translate }}
        </p>

        <h2 translate>
            privacy_policy_h3_7
        </h2>
        <p translate>
            privacy_policy_p8
        </p>

        <h2 translate>
            privacy_policy_h3_8
        </h2>
        <p translate>
            privacy_policy_p9
        </p>

        <h2 translate>
            privacy_policy_h3_9
        </h2>
        <p>
            {{ 'privacy_policy_p10_1' | translate }}
            <a routerLink="/contacts">{{ 'privacy_policy_p10_2' | translate }}</a>
            {{ 'privacy_policy_p10_3' | translate }}
        </p>
    </section>

    <button mat-flat-button routerLink="">{{ 'home' | translate }}</button>
</app-main-pages-container>